// SHOULD MATCH IN FE AND API REPOS
import { z } from 'zod';

export const CreateDealerDocumentSchema = z.object({
  dealerId: z.string().optional(),
  dealerName: z.string().min(2),
  firstName: z.string().min(2),
  lastName: z.string().min(2),
  email: z.string().email(),
  phone: z.string().min(10),
  description: z.string().optional(),
  date: z.date().transform((val) => val.getTime()),
  requestedDocuments: z.array(
    z.object({
      documentType: z.string(),
      description: z.string().optional(),
      otherDocumentType: z.string().optional(),
      fileUrl: z.string().optional(),
      fileName: z.string().optional(),
    })
  ),
});

export type CreateDealerDocument = z.TypeOf<typeof CreateDealerDocumentSchema>;

